// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Profile styles */
.MyProfile_container__i0nIp {
  max-width: 800px;
  margin: 300px auto;
  color: #333;
  background-color: transparent;
  border-radius: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  height: auto;
}
.MyProfile_profile__19ifT {
  text-align: center;
  position: relative; 
}

.MyProfile_profile-image__YLcZL {
  position: absolute;
  top: -10%;
  left: 50%;
  transform: translateX(-50%);
  width: 85px;
  height: 85px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid #4caf50;
}
.MyProfile_rectangle__pqyx8 {
  --r: 50px; 
  max-width: 800px; 
  height: auto; 
  border-radius: 20px; 
  background: #ffffff;
  mask: radial-gradient(var(--r) at top, #0000 calc(100% - 1px), #000);
  -webkit-mask: radial-gradient(
    var(--r) at top,
    #0000 calc(100% - 1px),
    #000
  ); 
  position: relative;
  overflow: hidden;
}
.MyProfile_profile-image-placeholder__lnfvh {
  width: 85px;
  height: 85px;
  border-radius: 50%;
  position: absolute;
  top: -10%;
  left: 50%;
  transform: translateX(-50%);
}
.MyProfile_name__4NZCE {
  font-size: 24px;
  font-weight: bold;
  margin: 10px 0;
  color: #333;
  margin-top: 70px ;
}

.MyProfile_email__PGbeR,
.MyProfile_phone__KM\\+vw,
.MyProfile_gender__k9SOF,
.MyProfile_type__Mdpnv,
.MyProfile_tenant__GlzXY,
.MyProfile_role__S2Q71,
.MyProfile_timestamp__Op6vj {
  font-size: 14px;
  margin: 5px 0;
  color: #555;
}

/* Tenant info */
.MyProfile_tenant_info__LOaoV {
  margin-top: 50px;
  font-size: 20px;
  color: #333;
}

.MyProfile_tenant-info__Nx3K3 {
  background-color: #f4f4f4;
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: calc(100% - 40px);
  max-width: 600px;
  margin: 10px auto;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  margin-bottom: 40px;
  
}
.MyProfile_tenant-image__JeNrw {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 30px;
  float: left;
  object-fit: cover;
}
.MyProfile_tenant-info__Nx3K3 {
  margin-top: 20px;
  text-align: center;
}
.MyProfile_tenant-info__Nx3K3 p {
  /* margin: 0; */
  line-height: 1.6;
  color: #555;
  text-align: left;
  margin-left: 20px;
}

/* Loading and error styles */
.MyProfile_loading__zxtFB,
.MyProfile_error__Gtawq {
  text-align: center;
  font-size: 18px;
  color: #888;
}

.MyProfile_error__Gtawq {
  color: red;
}

.MyProfile_input-field__-TZAu {
  display: block;
  margin: 10px auto;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 80%;
}
.MyProfile_inputWrapper__L\\+gmL{
  gap: 10px;
  display: flex;
  flex-direction: column;
}
.MyProfile_inputWrapper__L\\+gmL .MyProfile_input-field__-TZAu {
  width: 100%;
  padding: 16px;
  font-weight: 600;
  border: none;
  background: var(--seconadry-ic-bg);
  border-radius: 8px;
  color: var(--text-color);
  padding-right: 50px;
  outline: none;
}

.MyProfile_save-button__jWp0b {
  margin-top: 10px;
  padding: 10px 20px;
  font-size: 14px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.MyProfile_edit-button__OWC0j {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  color: #fff;
  background-color: #007bff;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}


.MyProfile_edit-button__OWC0j:hover,
.MyProfile_save-button__jWp0b:hover {
  background-color: #0056b3;
}

.MyProfile_edit-button__OWC0j {
  background-color: #007bff;
  color: #fff;
}

.MyProfile_edit-button__OWC0j:hover {
  background-color: #0056b3;
}

.MyProfile_save-button__jWp0b {
  background-color: #28a745;
  color: #fff;
}

.MyProfile_save-button__jWp0b:hover {
  background-color: #218838;
}
/* Modal Overlay */
.MyProfile_modal-overlay__0xagZ {
  position: fixed; 
  top: 0;
  left: 0;
  width: 100vw; 
  height: 100vh; 
  background-color: rgba(0, 0, 0, 0.7); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; 
}


.MyProfile_profile-overlay__lS\\+9w {
  position: fixed; 
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1; 
}

.MyProfile_modal__CRtJY {
  background: white;
  padding: 35px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  position: relative;
}
.MyProfile_modal-header__CFe5y {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.MyProfile_modal__CRtJY h2 {
  margin-bottom: 20px;
}

.MyProfile_modal-buttons__5kdkV {
  margin-top: 20px;
}

.MyProfile_save-button__jWp0b {
  background-color: #28a745;
  color: #fff;
  padding: 10px 30px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.MyProfile_save-button__jWp0b:hover {
  background-color: #218838;
}

.MyProfile_cancel-button__VlIIz {
  background-color: #dc3545;
  color: #fff;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-left: 10px;
  cursor: pointer;
}

.MyProfile_cancel-button__VlIIz:hover {
  background-color: var(--deleteHover);
}

/* Close Button */
.MyProfile_close-button__1JC8V {
  position: absolute;
  top: -20px;
  right: -18px;
  border: none;
  cursor: pointer;
  color: #666;
  z-index: 1;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

/* Responsive Design */
@media (max-width: 600px) {
  .MyProfile_container__i0nIp{
    margin: 60px 16px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }
  .MyProfile_input-field__-TZAu {
    width: 100%;
    margin: 10px 0;
  }
  .MyProfile_name__4NZCE{
    font-size: 24px;
  }
  .MyProfile_tenant_info__LOaoV{
    font-size: 18px;
  }
  .MyProfile_tenant-info__Nx3K3{
    margin-bottom: 20px;
  }
  .MyProfile_modal__CRtJY {
    padding: 20px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Component/MyProfile/MyProfile.module.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,oEAAoE;EACpE;;;;GAIC;EACD,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;;;;EAOE,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;;AAErB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;;EAEE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;AACvD;;;AAGA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;AACA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,2CAA2C;EAC7C;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Profile styles */\n.container {\n  max-width: 800px;\n  margin: 300px auto;\n  color: #333;\n  background-color: transparent;\n  border-radius: 20px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  position: relative;\n  height: auto;\n}\n.profile {\n  text-align: center;\n  position: relative; \n}\n\n.profile-image {\n  position: absolute;\n  top: -10%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 85px;\n  height: 85px;\n  object-fit: cover;\n  border-radius: 50%;\n  border: 2px solid #4caf50;\n}\n.rectangle {\n  --r: 50px; \n  max-width: 800px; \n  height: auto; \n  border-radius: 20px; \n  background: #ffffff;\n  mask: radial-gradient(var(--r) at top, #0000 calc(100% - 1px), #000);\n  -webkit-mask: radial-gradient(\n    var(--r) at top,\n    #0000 calc(100% - 1px),\n    #000\n  ); \n  position: relative;\n  overflow: hidden;\n}\n.profile-image-placeholder {\n  width: 85px;\n  height: 85px;\n  border-radius: 50%;\n  position: absolute;\n  top: -10%;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.name {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 10px 0;\n  color: #333;\n  margin-top: 70px ;\n}\n\n.email,\n.phone,\n.gender,\n.type,\n.tenant,\n.role,\n.timestamp {\n  font-size: 14px;\n  margin: 5px 0;\n  color: #555;\n}\n\n/* Tenant info */\n.tenant_info {\n  margin-top: 50px;\n  font-size: 20px;\n  color: #333;\n}\n\n.tenant-info {\n  background-color: #f4f4f4;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  width: calc(100% - 40px);\n  max-width: 600px;\n  margin: 10px auto;\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  margin-bottom: 40px;\n  \n}\n.tenant-image {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  margin-right: 30px;\n  float: left;\n  object-fit: cover;\n}\n.tenant-info {\n  margin-top: 20px;\n  text-align: center;\n}\n.tenant-info p {\n  /* margin: 0; */\n  line-height: 1.6;\n  color: #555;\n  text-align: left;\n  margin-left: 20px;\n}\n\n/* Loading and error styles */\n.loading,\n.error {\n  text-align: center;\n  font-size: 18px;\n  color: #888;\n}\n\n.error {\n  color: red;\n}\n\n.input-field {\n  display: block;\n  margin: 10px auto;\n  padding: 8px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 80%;\n}\n.inputWrapper{\n  gap: 10px;\n  display: flex;\n  flex-direction: column;\n}\n.inputWrapper .input-field {\n  width: 100%;\n  padding: 16px;\n  font-weight: 600;\n  border: none;\n  background: var(--seconadry-ic-bg);\n  border-radius: 8px;\n  color: var(--text-color);\n  padding-right: 50px;\n  outline: none;\n}\n\n.save-button {\n  margin-top: 10px;\n  padding: 10px 20px;\n  font-size: 14px;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.edit-button {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  cursor: pointer;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n\n\n.edit-button:hover,\n.save-button:hover {\n  background-color: #0056b3;\n}\n\n.edit-button {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.edit-button:hover {\n  background-color: #0056b3;\n}\n\n.save-button {\n  background-color: #28a745;\n  color: #fff;\n}\n\n.save-button:hover {\n  background-color: #218838;\n}\n/* Modal Overlay */\n.modal-overlay {\n  position: fixed; \n  top: 0;\n  left: 0;\n  width: 100vw; \n  height: 100vh; \n  background-color: rgba(0, 0, 0, 0.7); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000; \n}\n\n\n.profile-overlay {\n  position: fixed; \n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.7); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1; \n}\n\n.modal {\n  background: white;\n  padding: 35px;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n.modal-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.modal h2 {\n  margin-bottom: 20px;\n}\n\n.modal-buttons {\n  margin-top: 20px;\n}\n\n.save-button {\n  background-color: #28a745;\n  color: #fff;\n  padding: 10px 30px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.save-button:hover {\n  background-color: #218838;\n}\n\n.cancel-button {\n  background-color: #dc3545;\n  color: #fff;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n.cancel-button:hover {\n  background-color: var(--deleteHover);\n}\n\n/* Close Button */\n.close-button {\n  position: absolute;\n  top: -20px;\n  right: -18px;\n  border: none;\n  cursor: pointer;\n  color: #666;\n  z-index: 1;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n\n/* Responsive Design */\n@media (max-width: 600px) {\n  .container{\n    margin: 60px 16px;\n    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n  }\n  .input-field {\n    width: 100%;\n    margin: 10px 0;\n  }\n  .name{\n    font-size: 24px;\n  }\n  .tenant_info{\n    font-size: 18px;\n  }\n  .tenant-info{\n    margin-bottom: 20px;\n  }\n  .modal {\n    padding: 20px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MyProfile_container__i0nIp`,
	"profile": `MyProfile_profile__19ifT`,
	"profile-image": `MyProfile_profile-image__YLcZL`,
	"rectangle": `MyProfile_rectangle__pqyx8`,
	"profile-image-placeholder": `MyProfile_profile-image-placeholder__lnfvh`,
	"name": `MyProfile_name__4NZCE`,
	"email": `MyProfile_email__PGbeR`,
	"phone": `MyProfile_phone__KM+vw`,
	"gender": `MyProfile_gender__k9SOF`,
	"type": `MyProfile_type__Mdpnv`,
	"tenant": `MyProfile_tenant__GlzXY`,
	"role": `MyProfile_role__S2Q71`,
	"timestamp": `MyProfile_timestamp__Op6vj`,
	"tenant_info": `MyProfile_tenant_info__LOaoV`,
	"tenant-info": `MyProfile_tenant-info__Nx3K3`,
	"tenant-image": `MyProfile_tenant-image__JeNrw`,
	"loading": `MyProfile_loading__zxtFB`,
	"error": `MyProfile_error__Gtawq`,
	"input-field": `MyProfile_input-field__-TZAu`,
	"inputWrapper": `MyProfile_inputWrapper__L+gmL`,
	"save-button": `MyProfile_save-button__jWp0b`,
	"edit-button": `MyProfile_edit-button__OWC0j`,
	"modal-overlay": `MyProfile_modal-overlay__0xagZ`,
	"profile-overlay": `MyProfile_profile-overlay__lS+9w`,
	"modal": `MyProfile_modal__CRtJY`,
	"modal-header": `MyProfile_modal-header__CFe5y`,
	"modal-buttons": `MyProfile_modal-buttons__5kdkV`,
	"cancel-button": `MyProfile_cancel-button__VlIIz`,
	"close-button": `MyProfile_close-button__1JC8V`
};
export default ___CSS_LOADER_EXPORT___;
